import Parse from '@/parse'
import { format } from 'date-fns'

export default {
  async get ({ commit }, id) {
    const event = new Parse.Object('EventClosed')
    event.set('objectId', id)

    let query = new Parse.Query('EventExport')
    query.equalTo('event', event)
    try {
      let object = await query.first()
      commit('setEventExport', object)
    } catch (error) {
      console.log(error)
    }
  }
}
